export default "__VITE_ASSET__Cj64v1$W__"